module.exports = __webpack_public_path__ + "img/fiberapi.21e50934.png";